<template>
	<section>
		<!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true" :model="filters" size="mini">
				<el-form-item>
					<el-input v-model="filters.roleName" placeholder="角色名"></el-input>
				</el-form-item>
				<el-form-item>
					<my-button  @select-type="clickBtn" QueryButtonShow AddButtonShow  ></my-button>
				</el-form-item>
			</el-form>
		</el-col>

		<!--列表-->
		<el-table :data="roles" highlight-current-row v-loading="listLoading" @selection-change="selsChange" style="width: 100%;" border :height="formHeight" size="mini">
			<el-table-column type="selection">
			</el-table-column>
			<el-table-column type="index" label="序号">
			</el-table-column>
			<el-table-column prop="roleName" label="角色名称" sortable>
			</el-table-column>
			<el-table-column prop="type" label="角色类型" sortable>
				<template slot-scope="scope">
					<span v-if="scope.row.type=='0'">员工</span>
					<span v-else>客户</span>
				</template>
			</el-table-column>
			<el-table-column prop="remark" label="描述" ></el-table-column>
			<el-table-column label="操作">
				<template slot-scope="scope">
					<table-setting-button  @select-type="handlePermission(scope.$index, scope.row)" btnCon="赋予权限">  </table-setting-button>
					<table-update-button  @select-type="handleEdit(scope.$index, scope.row)" ></table-update-button>
				</template>
			</el-table-column>
		</el-table>

		<!--工具条-->
		<el-col :span="24" class="toolbar">
			<el-pagination layout="total, sizes, prev, pager, next, jumper" @current-change="handleCurrentChange" :page-size="pageSize" :total="total" style="float:right;" :page-sizes="[10, 20, 30,40,50]"   @size-change="handleSizeChange" :current-page.sync="page">
			</el-pagination>
		</el-col>

		<!--Form界面 角色修改、添加-->
		<el-dialog :title="type" :visible.sync="formVisible" :close-on-click-modal="false">
			<el-form :model="formRole" label-width="80px" :rules="formRules" ref="formRole">
				<el-form-item label="角色名称">
					<el-input v-model="formRole.roleName" ></el-input>
				</el-form-item>
				<el-form-item label="角色类型">
					<el-select v-model="formRole.type" placeholder="请选择角色类型" >
						<el-option label="员工" value="0"></el-option>
						<el-option label="客户" value="1"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="描述">
					<el-input v-model="formRole.remark" ></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="cancleSubmit">取消</el-button>
				<el-button type="primary" @click.native="submitData" :loading="loading">提交</el-button>
			</div>
		</el-dialog>

		<!-- 角色授予权限页面 -->
		<el-dialog title="授予权限" :visible.sync="permissionVisible" :close-on-click-modal="false">
			<el-tree
				:data="dataPer" show-checkbox default-expand-all 
				node-key="permissionId"  ref="webTree" highlight-current :props="defaultProps"  :default-checked-keys="checkPer">
			</el-tree>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="cancleSubmit">取消</el-button>
				<el-button type="primary" @click.native="submitPermission" :loading="loading">提交</el-button>
			</div>
		</el-dialog>
	</section>
</template>

<script>
	import util from '../../common/js/util'
	//import NProgress from 'nprogress'
	import { getRoleList,roleQueryPermisson,roleAddPermission,saveOrUpdateRole } from '../../api/api';
	import {translateDataToTreePermission} from '../../../static/fun.js';

	import myButton from '../../components/myButton/index.vue'
	import TableUpdateButton from '../../components/myButton/TableUpdateButton.vue'
	import TableSettingButton from '../../components/myButton/TableSettingButton.vue'

	export default {
	components: { myButton,TableUpdateButton,TableSettingButton},
		data() {
			return {
				filters: {
					roleName: ''
				},
				dataPer:[],
				dataappPer:[],
				checkPer:[],
				checkappPer:[],
				roles: [],
				total: 0,
				page:1,
				pageSize:10,
				listLoading: false,
				sels: [],//列表选中列
				type:'新增',

				formVisible: false,//修改界面是否显示
				permissionVisible:false,//授予权限页面是否显示
				permissionappVisible:false,
				loading: false,
				formRules: {
					roleName: [
						{ required: true, message: '请输入角色名称', trigger: 'blur' }
					]
				},
				//修改界面数据
				formRole: {
					roleId: 0,
					roleName: '',
					type:"0",
					remark: ''
				},
				formHeight:0,
				permissionRoleId:0,
				defaultProps: {
					children: 'children',
					label: 'permissionName'
				},
			}
		},
		methods: {
			clickBtn(type){
				if(type=="query"){
					this.getRoles();
				}else if(type=="add"){
					this.handleAdd();
				}
			},
			handleCurrentChange(val) {
				this.page=val;
				this.getRoles();
			},
			handleSizeChange(val){
				this.pageSize=val;
				this.getRoles();
			},
			//获取用户列表
			getRoles() {
				let para = {
					page: this.page,
					pageSize:this.pageSize,
					roleName: this.filters.roleName
				};
				this.listLoading = true;
				getRoleList(para).then((res) => {
					
					this.total = res.data.data.total;
					this.roles = res.data.data.records;
					this.listLoading = false;
				});
			},
			//显示修改界面
			handleEdit: function (index, row) {
				this.formVisible = true;
				if( this.$refs.formRole!=undefined){
               		this.$refs.formRole.resetFields();
				}
				this.type='修改';
				row.type=row.type.toString();
				this.formRole = Object.assign({}, row);
			},
			//显示授予权限界面
			handlePermission: function (index, row) {
				this.dataPer=[];
				this.checkPer=[];
				this.permissionRoleId=row.roleId;
				//获取角色权限
				let para = {
					roleId:row.roleId
				};
				roleQueryPermisson(para).then((res) => {
					
					let resData = res.data;
					if (resData.code != 200) {
						this.$message({
						message: resData.msg,
						type: 'error'
					})}else{
						var child=translateDataToTreePermission(resData.data.permissionList);	
						this.dataPer=JSON.parse(JSON.stringify(child));
						this.checkPer=resData.data.checkedPermissionIds;
						this.permissionVisible = true;						
					}
				});
			},
			//对角色进行授权
			submitPermission:function(){
				this.loading = true;

				var para=new URLSearchParams();
				para.append('permissionIds', this.$refs.webTree.getCheckedKeys());
				para.append('roleId',this.permissionRoleId);

				roleAddPermission(para).then((res) => {
					this.loading = false;
					
					let resData = res.data;
					if (resData.code != 200) {
						this.$message({
						message: '授权失败',
						type: 'error'
					})}else{
							this.$message({
							message: '授权成功',
							type: 'success'
						})					
					}
					this.permissionVisible = false;
				});
			},
			//显示新增界面
			handleAdd: function () {
				this.formVisible = true;
				if( this.$refs.formRole!=undefined){
               		this.$refs.formRole.resetFields();
				}
				this.type='新增';
				this.formRole = {
					roleId: 0,
					type:"0",
					roleName: '',
					remark: ''
				}
			},
			//Form表单提交
            submitData:function(){
                if(this.type=='修改'){
                   this.editSubmit();
                }else{
					this.addSubmit();
                }
            },
			//修改
			editSubmit: function () {
				this.$refs.formRole.validate((valid) => {
					if (valid) {
						this.$confirm('确认提交吗？', '提示', {}).then(() => {
							this.loading = true;
							let para = Object.assign({}, this.formRole);
							saveOrUpdateRole(para).then((res) => {
								this.loading = false;
								let resData = res.data;
								if (resData.code == 200) {
									this.$message({
										message: '操作成功',
										type: 'success'
									});
								}else{
									this.$message({
										message: resData.msg,
										type: 'error'
									})
								}
								this.formVisible = false;
								this.getRoles();
							});
						});
					}
				});
			},
			//新增
			addSubmit: function () {
				this.$refs.formRole.validate((valid) => {
					if (valid) {
						this.$confirm('确认提交吗？', '提示', {}).then(() => {
							this.loading = true;
							let para = Object.assign({}, this.formRole);
							saveOrUpdateRole(para).then((res) => {
								this.loading = false;
								let resData = res.data;
								if (resData.code == 200) {
									this.$message({
										message: '操作成功',
										type: 'success'
									});
								}else{
									this.$message({
										message: resData.msg,
										type: 'error'
									})
								}
								this.formVisible = false;
								this.getRoles();
							});
						});
					}
				});
			},
			selsChange: function (sels) {
				this.sels = sels;
			},
			//取消按钮
            cancleSubmit:function(){
				this.formVisible=false;
				this.permissionVisible=false;
				this.permissionappVisible=false;
			},
			SetHeight:function(){
				var hgt=document.getElementsByClassName('content-container')[0].clientHeight;
				var titleHgt=document.getElementsByClassName('tags-view-wrapper')[0].clientHeight;
				var toolbarHgt=document.getElementsByClassName('toolbar')[0].clientHeight+document.getElementsByClassName('toolbar')[1].clientHeight;
				this.formHeight=hgt-titleHgt-toolbarHgt-120;
			}
		},
		mounted() {
			var _this=this;
			var timer=null;
			clearInterval(timer);
			timer =setInterval(function(){
				if(_this.formHeight ==0){
					_this.SetHeight();
				}else{
					clearInterval(timer);
				}
			},10)
			this.getRoles();
		}
	}

</script>

<style scoped>
	.containerRole{
		display: flex;
	}
	.containerRole .block {
		-ms-flex: 1;
		flex: 1;
		padding: 0 24px;
	}
	.containerRole .title{
		font-weight: bold;
		margin-bottom: 10px;
	}
</style>


// WEBPACK FOOTER //
// Role.vue?a9f180ca